import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export function ThemeProvider({ children }) {
    const [theme, setTheme] = useState("theme-cream");

    useEffect(() => {
        document.body.classList.add("theme-cream");
    }, []);

    const clearTheme = () => {
        setTheme("theme-cream");
    };

    return (
        <ThemeContext.Provider value={{ theme, setTheme, clearTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

export const useTheme = () => useContext(ThemeContext);
